// console.log(window.navigator.userAgent)
var UNDEF_TYPE = 'undefined'
var EMPTY = ''
var FUNC_TYPE = 'function'
var OBJ_TYPE = 'object'
var STR_TYPE = 'string'
var VERSION = 'version'
var NAME = 'name'

var _ua =
  ((typeof window !== UNDEF_TYPE &&
    window.navigator &&
    window.navigator.userAgent)
    ? window.navigator.userAgent : EMPTY)
// var _rgxmap = extensions ? extend(regexes, extensions) : regexes;

var regexes = {
  browser: [
    [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [VERSION, [NAME, 'IE']]
  ]
}

function getBrowser () {
  var _browser = {}
  _browser[NAME] = undefined
  _browser[VERSION] = undefined
  rgxMapper.call(_browser, _ua, regexes.browser)
  _browser.major = majorize(_browser.version)
  // console.log(_browser)
  if (_browser.name === 'IE') {
    alert('本網頁不支援IE瀏覽器，請使用 Edge、Chrome、Safari、Firefox 等瀏覽器操作')
  }
  return _browser
}

function majorize (version) {
  return typeof (version) === STR_TYPE
    ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0]
    : undefined
}

function rgxMapper (ua, arrays) {
  // console.log(ua);
  // console.log(arrays);
  var i = 0; var j; var k; var p; var q; var matches; var match

  // loop through all regexes maps
  while (i < arrays.length && !matches) {
    var regex = arrays[i] // even sequence (0,2,4,..)
    var props = arrays[i + 1] // odd sequence (1,3,5,..)
    j = k = 0
    // console.log(regex);
    // console.log(props);
    // try matching uastring with regexes
    while (j < regex.length && !matches) {
      matches = regex[j++].exec(ua)

      if (matches) {
        for (p = 0; p < props.length; p++) {
          match = matches[++k]
          console.log(props[p])
          q = props[p]
          // check if given property is actually array
          if (typeof q === OBJ_TYPE && q.length > 0) {
            if (q.length == 2) {
              if (typeof q[1] === FUNC_TYPE) {
                // assign modified match
                this[q[0]] = q[1].call(this, match)
              } else {
                // assign given value, ignore regex match
                this[q[0]] = q[1]
              }
            } else if (q.length == 3) {
              // check whether function or regex
              if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                // call function (usually string mapper)
                this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined
              } else {
                // sanitize match using given regex
                this[q[0]] = match ? match.replace(q[1], q[2]) : undefined
              }
            } else if (q.length == 4) {
              this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined
            }
          } else {
            this[q] = match || undefined
          }
        }
      }
    }
    i += 2
  }
}

export default getBrowser()



// WEBPACK FOOTER //
// ./src/utils/judgment_ie.js